import { REACT_SELECT_STYLES } from "configurations/Constants";
import {
  SELECT_OR_CREATE_TAGS,
  TYPE_TO_CREATE_A_NEW_TAG,
} from "configurations/MessageConstants";
import React from "react";
import CreatableSelect from "react-select/creatable";

const NoteTagPicker = ({
  selectedTags = [],
  onTagsChange,
  isDisabled = false,
  notesTags = [],
}) => {
  const formatTagsForSelect = (tags) => {
    return tags.map((tag) => ({ value: tag, label: tag }));
  };
  const formatNotesTagsForOptions = (tags) => {
    return tags.map((tag) => ({ value: tag.name, label: tag.name }));
  };

  const formatTagsFromSelect = (selectedOptions) => {
    return selectedOptions ? selectedOptions.map((option) => option.value) : [];
  };

  const handleChange = (selectedOptions) => {
    const tags = formatTagsFromSelect(selectedOptions);
    onTagsChange(tags);
  };

  return (
    <CreatableSelect
      isMulti
      value={formatTagsForSelect(selectedTags)}
      onChange={handleChange}
      placeholder={SELECT_OR_CREATE_TAGS}
      styles={REACT_SELECT_STYLES}
      isDisabled={isDisabled}
      isClearable={false}
      options={formatNotesTagsForOptions(notesTags)}
      noOptionsMessage={() => TYPE_TO_CREATE_A_NEW_TAG}
    />
  );
};

export default NoteTagPicker;
